import * as Yup from 'yup';

export const supportListSchema = Yup.object({
  Description: Yup.string().required('Description is required'),
});
